import Model from 'flarum/common/Model';

export default class Figure extends Model {
  slug = Model.attribute('slug');
  translation = Model.attribute('translation');
  name = Model.attribute('name');
  type = Model.attribute('type');
  aliases = Model.attribute('aliases');
  activeYears = Model.attribute('activeYears');
  description = Model.attribute('description');
  clubSlugs = Model.attribute('clubSlugs');
  role = Model.attribute('role');
  forumMentions = Model.attribute('forumMentions');
  hasStory = Model.attribute('hasStory');
  isIndexed = Model.attribute('isIndexed');
  bioHtml = Model.attribute('bioHtml');
  timeline = Model.attribute('timeline');
  clubs = Model.attribute('clubs');
  anecdotes = Model.attribute('anecdotes');
  sources = Model.attribute('sources');
  searchNames = Model.attribute('searchNames');
  isVerified = Model.attribute('isVerified');
  portrait = Model.attribute('portrait');
  photos = Model.attribute('photos');

  shownAliases() {
    return (this.aliases() || []).filter((a) => a !== this.name());
  }

  searchText() {
    return [this.name(), ...(this.aliases() || []), this.role()].filter(Boolean).join(' ').toLowerCase();
  }
}
